import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import CustomNavbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";

function ClinicMap() {

    const sendWhatsApp = (e) => {
        e.preventDefault();

        const name = e.target.name.value;
        const email = e.target.email.value;
        const subject = e.target.subject.value;
        const message = e.target.message.value;

        const phone = "919511291664";

        const text = `Hello Doctor,%0A
Name: ${name}%0A
Email: ${email}%0A
Subject: ${subject}%0A
Message: ${message}`;

        const whatsappURL = `https://wa.me/${phone}?text=${text}`;

        window.open(whatsappURL, "_blank");
    };

    return (
        <>
            <CustomNavbar />

            <section className="map-section py-5">
                <Container>

                    {/* Heading */}
                    <Row className="text-center mb-4">
                        <Col>
                            <h2 className="fw-bold">CONTACT US</h2>
                        </Col>
                    </Row>

                    {/* Map */}
                    <Row className="justify-content-center">
                        <Col md={10}>
                            <div
                                style={{
                                    overflow: "hidden",
                                    borderRadius: "12px",
                                    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                                }}
                            >
                                <iframe
                                    title="dr-trupti-clinic-location"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3779.656611881282!2d73.86495487496695!3d18.67939908244522!2m3!1f0!3f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c91aba89626b%3A0x70af8cfe488ce9a0!2sDR.%20TRUPTI'S%20Health%20%26%20Beauty%20Clinic!5e0!3m2!1sen!2sin!4v1773053814663!5m2!1sen!2sin"
                                    width="100%"
                                    height="420"
                                    style={{ border: 0 }}
                                    allowFullScreen
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                ></iframe>
                            </div>

                            <div className="text-center mt-4 mb-4">
                                <Button
                                    variant="dark"
                                    href="https://maps.google.com/?q=DR.TRUPTI'S Health & Beauty Clinic"
                                    target="_blank"
                                    className="me-3"
                                >
                                    📍 View on Google Maps
                                </Button>
                            </div>
                        </Col>
                    </Row>

                    {/* Row 2 */}
                    <Row>

                        {/* LEFT SIDE CONTACT BOXES */}
                        <Col md={5} className="mb-4">

                            <Card className="mb-3 shadow-sm">
                                <Card.Body className="d-flex">
                                    <FaMapMarkerAlt size={30} style={{ color: "#bc6c25 " }} className="me-3" />
                                    <div>
                                        <h6 className="fw-bold">Location</h6>
                                        <p className="mb-0">
                                            shop no.-5, Ground floor, Destination Ostia,
                                            Moshi Gaon, Pimpri-Chinchwad
                                        </p>
                                    </div>
                                </Card.Body>
                            </Card>

                            <Card className="mb-3 shadow-sm">
                                <Card.Body className="d-flex">
                                    <FaEnvelope size={30} style={{ color: "#bc6c25 " }} className="me-3 " />
                                    <div>
                                        <h6 className="fw-bold">Email</h6>
                                        <p className="mb-0">truptihambire111@gmail.com</p>
                                    </div>
                                </Card.Body>
                            </Card>

                            <Card className="shadow-sm">
                                <Card.Body className="d-flex">
                                    <FaPhoneAlt size={30} style={{ color: "#bc6c25 " }} className="me-3" />
                                    <div>
                                        <h6 className="fw-bold">Phone</h6>
                                        <p className="mb-0">+91 9511291664</p>
                                    </div>
                                </Card.Body>
                            </Card>

                        </Col>

                        {/* RIGHT SIDE FORM */}
                        <Col md={7}>

                            <Card className="p-4 shadow-sm">
                                <Form onSubmit={sendWhatsApp}>

                                    <Row className="mb-3">
                                        <Col md={6}>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                placeholder="Your Name"
                                                required
                                            />
                                        </Col>

                                        <Col md={6}>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                placeholder="Your Email"
                                                required
                                            />
                                        </Col>
                                    </Row>

                                    <Form.Group className="mb-3">
                                        <Form.Control
                                            type="text"
                                            name="subject"
                                            placeholder="Subject"
                                            required
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Control
                                            as="textarea"
                                            rows={5}
                                            name="message"
                                            placeholder="Message"
                                            required
                                        />
                                    </Form.Group>

                                    <Button
                                        type="submit"
                                        style={{
                                            backgroundColor: "#bc6c25",
                                            border: "none",
                                            color: "#fff"
                                        }}
                                    >
                                        Send Message
                                    </Button>

                                </Form>
                            </Card>

                        </Col>

                    </Row>

                </Container>
            </section>

            <Footer />

        </>
    );
}

export default ClinicMap;